import axios from 'axios';
import Sortable from 'sortablejs';

export default class psProfileContacts {

    constructor() {
        const container = document.getElementById('profile-contacts');

        if (!container) {
            return;
        }

        const list = container.querySelector('.contacts-list-wrapper');
        const search = document.getElementById('profile-contact-search');

        if (!(list && search)) {
            return;
        }

        this.container = container;
        this.listContainer = list;
        this.searchContainer = search;

        this._initAdd();
        this._initEdit();
    }

    _initAdd() {
        // Laddindikator
        const loader = this.searchContainer.querySelector('.ajax-loading');
        const toggleLoader = visible => loader.toggleAttribute('hidden', !visible);

        const addButton = this.container.querySelector('.add-contacts-button');

        // �ppna "L�gg till"-meny
        addButton.addEventListener('click', event => {
            var content = document.getElementById(event.target.getAttribute('aria-controls'));
            if (content) {
                const expanded = event.target.getAttribute('aria-expanded') === 'true';
                event.target.setAttribute('aria-expanded', !expanded);
                content.toggleAttribute('hidden', expanded);
            }
        });

        // St�ng "L�gg till"-meny
        this.searchContainer.querySelector('.close-button').addEventListener('click', () => {
            this.searchContainer.toggleAttribute('hidden', true);
            addButton && addButton.setAttribute('aria-expanded', false);

            // Open when we close the search box (mobile)
            if (window.innerWidth < 768) {
                const list = document.getElementById('collapsable-contacts-list');
                const expandedArrow = document.querySelector('[aria-controls="' + list.id + '"]');
                if (expandedArrow && expandedArrow.getAttribute('aria-expanded') !== 'true') {
                    expandedArrow.setAttribute('aria-expanded', true);
                    if (list) {
                        list.classList.remove('profile__mobile-hide');
                        expandedArrow.classList.add('profile__mobile-expand--modifier');
                    }
                }
            }

            this._toggleEditList(false);
        });

        // S�kfunktion
        const input = this.searchContainer.querySelector('.search-input');
        const searchResult = this.searchContainer.querySelector('.search-result');
        let timer;

        input.addEventListener('input', () => {
            clearTimeout(timer);

            if (input.value.length < 3) {
                searchResult.innerHTML = '';
                toggleLoader(false);
                return;
            }

            toggleLoader(true);

            timer = setTimeout(async () => {
                try {
                    // { params: {} } g�r en querystring av objektet
                    const response = await axios.get("/api/ps/profile/contacts/search", { params: { text: input.value } });
                    searchResult.innerHTML = response.data;
                } catch (error) {
                    this._error(error);
                }
                toggleLoader(false);
            }, 700);
        });

        // L�gg till kontakt
        searchResult.addEventListener('click', async event => {
            event.preventDefault();
            const trigger = event.target;

            if (!trigger.classList.contains('add-contacts')) {
                return;
            }

            toggleLoader(true);

            try {
                await axios.post("/api/ps/profile/contacts/add", { id: trigger.getAttribute('data-id') });

                trigger.style.display = "none";

                if (trigger.nextElementSibling) {
                    trigger.nextElementSibling.style.display = "block";
                } else {
                    var img = document.createElement('img');
                    img.src = "/img/ps-icons/check.svg";
                    img.alt = "check";
                    trigger.parentNode.insertBefore(img, trigger.nextElementSibling);
                }

                const response = await axios.get("/api/ps/profile/contacts");

                this.container.querySelector('.contacts-list-wrapper').innerHTML = response.data; // inneh�ller b�de lista och sortable....
                this._updateSortable();
            } catch (error) {
                this._error(error);
            }

            toggleLoader(false);
        });

        document.addEventListener('DOMContentLoaded', () => this._updateSortable());
    }

    _initEdit() {
        const loader = this.container.querySelector('.ajax-loading');
        const toggleLoader = visible => loader.toggleAttribute('hidden', !visible);

        // Redigering kontakter ("kugghjul")
        this.container.querySelector('.edit-contacts-button').addEventListener('click', () => this._toggleEditList());

        // Ta bort kontakt
        this.listContainer.addEventListener('click', async event => {
            const trigger = event.target;

            if (!trigger.classList.contains('remove-contact')) {
                return;
            }

            event.preventDefault();
            toggleLoader(true);
            const id = trigger.getAttribute('data-id');

            try {
                await axios.post("/api/ps/profile/contacts/remove", { id });
                trigger.parentElement.remove();
                const link = document.querySelector('#collapsable-contacts-list a[data-id="' + id + '"]');
                link && link.remove();
            } catch (error) {
                this._error(error.status);
            }

            toggleLoader(false);
        });
    }

    _toggleEditList(visible) {
        const list = document.getElementById('collapsable-contacts-list');
        const editList = document.getElementById('profile-edit-contacts');
        const btn = this.container.querySelector(`[aria-controls="${editList.id}"]`);

        visible = visible == null ? !(btn.getAttribute('aria-expanded') === 'true') : visible === true;

        list.toggleAttribute('hidden', visible);
        editList.toggleAttribute('hidden', !visible);
        btn.setAttribute('aria-expanded', visible);
        btn.classList.toggle('checked', visible);
    }

    _updateSortable() {
        if (this.sortable) {
            this.sortable.destroy();
        }

        const node = document.getElementById('profile-edit-contacts-wrapper');

        if (!node) {
            return;
        }

        const options = {
            handle: '.added-contact-item__drag-wrapper',
            onUpdate: async event => {
                const items = event.from.querySelectorAll('.added-contact-item');

                if (!items.length) {
                    return;
                }

                const contacts = new Array(items.length);

                for (let i = 0; i < items.length; i++) {
                    items[i].setAttribute('data-index', i);
                    contacts[i] = items[i].getAttribute('data-id');
                }

                try {
                    const response = await axios.post("/api/ps/profile/contacts/sort", contacts);
                    // inneh�ller bara lista...
                    const div = document.createElement('div');
                    div.innerHTML = response.data;
                    const list = document.getElementById('collapsable-contacts-list');
                    list.replaceWith(div.firstElementChild);
                } catch (error) {
                    this._error(error);
                }
            }
        };

        this.sortable = Sortable.create(node, options);
    }

    _error(error) {
        const id = error && error.response && error.response.status === 401 ? 'ps-profile-logged-out' : 'ps-profile-generic-error';
        alert(document.getElementById(id).value);
    }
}
